import Installation from './01.installation';
import Domain from './02.domain';

const XP = [
    Installation,
    ...Domain
];

export default XP;